import { UpdateAttributeRequest, CUSTOM_ATTRIBUTE_ROUTES } from "@zeal/common";
import { IAxiosInstance } from "../../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../../AbstractApiClient/IApiResponse";

export const updateAttribute = (axios: IAxiosInstance) => {
  return async (data: UpdateAttributeRequest) => {
    const response = await axios.noRetry.patch<IApiResponse<any>>(
      `${CUSTOM_ATTRIBUTE_ROUTES.UPDATE_ATTRIBUTE.replace(
        ":attributeID",
        data.attributeID
      )}`,
      data
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
